import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LoadingSpinner } from '@/components/auth'
import { supabase } from '@/lib/supabase'
import { consumePostLoginPath } from '@/lib/utils'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [isProcessing, setIsProcessing] = useState(true)

  // Check for password reset flow immediately, before any useEffect
  const type = searchParams.get('type')
  const isPasswordReset = type === 'recovery'

  useEffect(() => {
    if (isPasswordReset) {
      // This is a password reset callback - redirect immediately
      // Set a flag to indicate we're in password reset flow
      sessionStorage.setItem('password-reset-flow', 'true')
      navigate('/reset-password', { replace: true })
      return
    }

    // For non-recovery flows, handle normally with delay
    const handleCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession()

        if (error) {
          console.error('Error getting session:', error)
          navigate('/login', { replace: true })
          return
        }

        if (data.session) {
          // Normal login callback - back to where the user was going (default: dashboard)
          navigate(consumePostLoginPath(), { replace: true })
        } else {
          // No session found - redirect to login
          navigate('/login', { replace: true })
        }
      } catch (error) {
        console.error('Callback error:', error)
        navigate('/login', { replace: true })
      } finally {
        setIsProcessing(false)
      }
    }

    const timeout = setTimeout(handleCallback, 500)
    return () => clearTimeout(timeout)
  }, [navigate, isPasswordReset])

  if (!isProcessing) return null

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-muted-foreground">Processing authentication...</p>
    </div>
  )
}
